
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rat-race/user-agreement",
      function () {
        return require("private-next-pages/rat-race/user-agreement.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rat-race/user-agreement"])
      });
    }
  